<template>
    <div>
        <breadCrumb 
            :icon="'fa-tools'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_configuration`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in tab" :key="t.id">
                <a class="nav-link  bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="handleTabSelection(t.id)">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <div v-for="t in tab" :key="t.id" :class="{'active': t.id == selectedTab }" class="tab-pane">
                <div class="px-3 px-sm-5 py-4">
                    <div class="panel mb-0">
                        <div class="panel-hdr">
                            <h2>{{t.text}}{{$t(`subMenu.salon_menu_configuration`)}}</h2>
                        </div>
                        <div class="panel-container">
                            <div class="panel-content">
                                <form @submit.prevent="editCategoryConfiguration">
                                    <input type="hidden" v-model="selectedTab"/>
                                    <div class="row">
                                        <div class="col-lg-6 col-xl-6 p-3 border-right">
                                            <div class="form-group" v-for="(resutlt, index) in results.slice(0,3)" :key="index">
                                                <label class="form-label">{{$t('label.category')}} {{index + 1}}</label>
                                                <div class="input-group bg-white shadow-inset-2">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-transparent border-right-0">
                                                            <i class="fas fa-folder-open"></i>
                                                        </span>
                                                    </div>
                                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.category') + ' ' + (index + 1)" v-model="results[index]">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xl-6 p-3">
                                            <div class="form-group" v-for="(resutlt, index) in results.slice(2,5)" :key="index">
                                                <label class="form-label">{{$t('label.category')}} {{index + 4}}</label>
                                                <div class="input-group bg-white shadow-inset-2">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-transparent border-right-0">
                                                            <i class="fas fa-folder-open"></i>
                                                        </span>
                                                    </div>
                                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.category') + ' ' + (index + 4)" v-model="results[index + 3]">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-left mb-3">
                                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../Bread_Crumb'
import {getCategoryList, handleSessionExpired} from './../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuConfiguration',
    components:{
        BreadCrumb
    },
    data(){
        return{
            selectedTab: 'service',
            categoryList: [],
            data: {}, results: [],
        }
    },
    computed:{
        tab(){
            var arr = []
            var tab = this.$i18n.messages[this.$i18n.locale].salon_report.item_types
            for(var i in tab){
                if(i != 'outstandings')
                arr.push({
                    id: i,
                    text: tab[i]
                })
            }
            return arr
        }
    },
    methods:{
        handleTabSelection(id){
            this.selectedTab = id;

            for(var d in this.data){
                if(d == id){
                    this.results = this.data[d];
                    break;
                }
            }
        },
        editCategoryConfiguration(){
            let $vm = this;
            var data = this.data;
            var _data = {};

            Object.keys(data).forEach(function(key){
                if(key == $vm.selectedTab){
                    var i = 0;
                    var arrLength = data[key].length;
                    data[key] = [];
                    while(i < arrLength){
                        data[key].push($vm.results[i]);
                        i++;
                    }
                }
                _data[key] = data[key]
            })

            $vm.$axios({
                method: 'post', 
                url: $vm.$api.MENU_CATEGORY,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: _data
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.salon_menu_configuration') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        closeModal(isError){
            if(!isError){
                getCategoryList(this);
                this.selectedTab = "service";
                this.data = JSON.parse(this.$store.state.category);
                this.results = this.data.service;
            }
            this.$parent.isModalShow = false;
        },
    },
    mounted(){
        let $vm = this;
        $vm.data = JSON.parse($vm.$store.state.category);
        $vm.results = $vm.data.service;
    }
}
</script>